import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import { FaLinkedin, FaTwitter, FaEnvelope } from "react-icons/fa";
import "./header.scss";

const Header = ({ social }) => (
  <header>
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `16px 1.0875rem`,
      }}
      className="header__inner-container"
    >
      <div className="header__title-wrapper">
        <Link to="/" className="header__title">
          <span className="header__title-letter white">A</span>
          <span className="header__title-letter white">n</span>
          <span className="header__title-letter white">d</span>
          <span className="header__title-letter white">y</span>
          <span
            className="header__title-letter white"
            style={{ marginLeft: 4 }}
          >
            C
          </span>
          <span className="header__title-letter white">o</span>
          <span className="header__title-letter white">u</span>
          <span className="header__title-letter white">p</span>
          <span className="header__title-letter white">e</span>
          {/* <span className="role">dev</span> */}
        </Link>
      </div>
      <div className="social-wrapper">
        <a
          aria-label="Email me"
          href="mailto:andrewmcoupe@gmail.com"
          className="header__theme-button"
          style={{ marginRight: 8 }}
        >
          <FaEnvelope />
        </a>
        <a
          aria-label="Connect with me on Linked in"
          target="_blank"
          rel="noopener noreferrer"
          href={social.linkedin}
          className="header__theme-button"
          style={{ marginRight: 8 }}
        >
          <FaLinkedin />
        </a>

        <a
          aria-label="Follow me on Twitter"
          rel="noopener noreferrer"
          target="_blank"
          href={social.twitter}
          className="header__theme-button"
        >
          <FaTwitter />
        </a>
      </div>
    </div>
  </header>
);

export default Header;
